import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_URL = 'https://backupmeraki.com'

export default function CanonicalLink() {
  const { pathname } = useLocation()

  useEffect(() => {
    const normalizedPath =
      pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname
    const canonicalUrl = `${SITE_URL}${normalizedPath || '/'}`
    let canonicalLink = document.querySelector('link[rel="canonical"]')

    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }

    canonicalLink.setAttribute('href', canonicalUrl)
  }, [pathname])

  return null
}
